export default {
  data: function data() {
    return {
      isOpen: false
    };
  }
};